import React, {useState, useEffect} from 'react';
import {VisDiv, TextField, FieldDropdown } from '..';
import {euro, percentage, sortByOrder} from '../../lib/utils'; 
import { IoIosEye, IoIosEyeOff} from 'react-icons/io';
import RichTextEditor from '../RichTextEditor';
import {FiSave } from 'react-icons/fi'
import { generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { RiInsertRowTop } from "react-icons/ri";
import { isGodMode } from '../../lib/userPermissions';
import { useStateContext } from '../../context/StateContext';

export const EditableProduct = ({data}) => {

    const {pr, index, commonStyle, edit, offer, updatedOffer, updateDataArray, dataArray, screenSizeDesktop, register, nonConformities} = data
    const {sUser } = useStateContext()
    //const product = generatedOfferWithTotalsDoc(offer?.offerFields?.find?.((x)=>x?._id == pr?._id))
    const product = generatedOfferWithTotalsDoc(pr)
    const [unit, setUnit] = useState()
    const [deviceNonConformity, setDeviceNonConformity] = useState()
    const rowColour = index % 2 ? "#FFECBA":"#FFF6DE"
    useEffect(()=>{ setUnit( product?.unit? product?.unit : "1")},[product?.unit])
    const showLine = () => {
  
      const visibleDoc = (doc) => ({...doc, hide: false})
      //console.log("SHOW LINE", product, offer)
      //setIsEditingOffer(true)
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), visibleDoc(product) ]?.sort(sortByOrder)
      updateDataArray(updatedData)      
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), visibleDoc(product) ]}
      updatedOffer(updatedOfferDoc)
    }
    const hideLine = (e) => {
      e.stopPropagation()
      const hiddenDoc = (item) => ({...item, hide: true})
      console.log("HIDE LINE", product)
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), hiddenDoc(product) ]?.sort(sortByOrder)
      console.log("UPDATED DATA", updatedData)
      updateDataArray(updatedData)
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), hiddenDoc(product) ]}
      updatedOffer(updatedOfferDoc)
    }
    const editProduct = (e) => {
      e.stopPropagation()
      const newUnitDoc = (item) => (generatedOfferWithTotalsDoc({
        ...item,  
        deviceNonConformityId: deviceNonConformity?._id ? deviceNonConformity?._id : item?.deviceNonConformityId, 
        quantity: Number(unit) ? Number(unit) : 1, unit: unit ? unit : "1" }
      ))
      console.log("EDIT UNIT", newUnitDoc(product))
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), newUnitDoc(product) ]?.sort(sortByOrder)
      console.log("UPDATED DATA", updatedData)
      updateDataArray(updatedData)
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), newUnitDoc(product) ]}
      updatedOffer(updatedOfferDoc, true)
    }
    const devices = !Array.isArray(register?.devices) ? [] : register?.devices
    const device = devices?.find((x)=>x?._id == product?.deviceId)
    const deviceNonConformitiesExpanded = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities
      ?.map((dNc => {
        const nonConformity = nonConformities?.find((x)=>x?._id == dNc?.nonConformity?._ref)
        return ({...dNc, nonConformity, label: nonConformity?.label, value: dNc?._id})
      }))
    const testProductLine = (e) => {
      e?.stopPropagation()
      console.log("testProductLine wkdnkwdnkjwdnkdje", {product, device, deviceNonConformitiesExpanded})
      //console.log("testProductLine", product, "in offer", offer?.offerFields?.find?.((x)=>x?._id == product?._id), "addedLocations", offer?.offerFields?.filter?.((x)=>x?.addedLocation))
      //console.log("offer", offer?.offerFields?.find?.((x)=>x?._id == "88cb10ac-6afd-4558-848b-78ee07fde9f3"))
    }
    return (
      <div onClick={(e)=>testProductLine(e)} key={index} style={{backgroundColor:product?.hide ? "#C0C0C0" : rowColour, marginLeft:"35px", marginBottom:"5px", color:"#324d67"}} >
        <VisDiv rules={[isGodMode(sUser)]}>
          <button onClick={(e)=>testProductLine(e)}>
            TEST PRODUCT LINE
          </button>
        </VisDiv>
        <VisDiv style={{zValue:1000, marginTop:"10px", color:"#324d67", display:"flex", alignItems:"center"}}>
        <p style={{color:"#324d67", marginRight:"5px", marginLeft:"10px"}}>Modifica Quantità:</p>
        <TextField 
            //onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
            style={{maxWidth: "400px", marginTop:"20px"}}
            value={unit} 
            onChange={(e) => {
                console.log("UNITA' NO POSITION")
                setUnit(e.target.value)
            }} 
            type={"text"}
        />
          <VisDiv rules={[true]}>
        
                <FieldDropdown
                  isMulti={false}
                  isSearchable="isSearchable"
                  initialValue={deviceNonConformitiesExpanded?.find((x)=>x?._id == product?.deviceNonConformityId)}
                  placeHolder={"ASSEGNA A NON CONFORMITA'"}
                  options={deviceNonConformitiesExpanded?.filter((x)=>x?.status !== "ARCHIVIATO" && x?.status !== "COMPLETATO")}
                  onChange={(value) => {
                    setDeviceNonConformity(value)
                  }
                  } 
              />
          </VisDiv>
        <button type='button' className='round-back-button' style={{backgroundColor:"green", marginLeft:"10px"}} onClick={editProduct}>
            <FiSave            
            size={15}
            color={"white"}/>
        </button>
        </VisDiv>
    <VisDiv style={{display:"flex", alignItems:"center"}}>
        <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv className='round-back-button' style={{backgroundColor:"grey"}} rules={[product?.hide]} onClick={(e) => {showLine()}}>
                <IoIosEyeOff fontSize={20} color='white'/>
            </VisDiv>
            <VisDiv className='round-back-button' style={{backgroundColor:"green"}} rules={[!product?.hide]} onClick={(e) => {hideLine(e)}}>
                <IoIosEye fontSize={20} color='white' />
            </VisDiv>
            <VisDiv rules={[false]}><button onClick={testProductLine}>testProductLine</button></VisDiv>
        </VisDiv>
        <VisDiv style={{color:"darkBlue", marginLeft:"10px"}} rules={[product?.addedLocation]}>
        <RiInsertRowTop fontSize={25} color='grey'/>
        </VisDiv>
    </VisDiv>
      <div style={{display:"flex", marginBottom:"5px"}}>
        <div style={{...commonStyle(edit), textAlign:"center"}}>
          {product?.pricelistCode}
        </div>
        <div style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.law} readOnly={true}/>
        </div>
        <div style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.description} readOnly={true}/>
        </div>
        <div style={{...commonStyle(edit), flex:1.2, minWidth: "85px"}}>
          <span>
          {product?.location}
          </span>
        </div>
        <div style={{...commonStyle(edit)}}>
          {product?.quantity}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.unitPrice)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {percentage(product?.discount)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.discountedUnitPrice)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.priceToClient)}
        </div>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.supplierPrice)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.totalCost)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop, false]}  style={{...commonStyle(edit)}}>
          {product?.labourHours}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {percentage(product?.margin)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.profit)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.unitProfit)}
        </VisDiv>
      </div>

  </div>
    )
}